import { Link, useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../../components/panel/panel';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import axiosClient from '../../../../../config/axios';
import BankAccountFields from './bankAccountsFields';


function NewBankAccount() {
    const navigate = useNavigate();
    const { Formik } = formik;

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Catálogos</li>
                        <li className="breadcrumb-item"><Link to="/catalogs/bankAccounts">Cuentas bancarias</Link></li>
                        <li className="breadcrumb-item active">Nueva Cuenta bancaria</li>
                    </ol>
                    <h1 className="page-header mb-0">Registro de nueva Cuenta bancaria</h1>
                </div>
            </div>



            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Registro de nueva Cuenta bancaria</PanelHeader>
                        <PanelBody>
                            <Formik
                                validationSchema={yup.object().shape({
                                    account_number: yup.string().required("Ingrese el número de cuenta"),
                                    bank_id: yup.object().required("Seleccione el banco"),
                                    destination_company: yup.string().required("Seleccione la empresa destino"),
                                })}
                                onSubmit={(values, { setSubmitting }) => {
                                    setSubmitting(false);

                                    axiosClient.post('/bankAccounts/save', values).then(response => {

                                        Swal.fire({
                                            title: 'Registro exitoso.',
                                            text: 'Se ha registrado la nueva Cuenta bancaria',
                                            icon: 'success',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                        navigate('/catalogs/bankAccounts');
                                    }).catch(err => {
                                       // console.log(err);
                                        const message = err.response.data.message;

                                        Swal.fire({
                                            title: 'Ups!',
                                            text: message,
                                            icon: 'error',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                    });
                                }}
                                initialValues={{
                                    account_number: '',
                                    bank: ''
                                }}
                            >
                                {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
                                    <Form noValidate onSubmit={handleSubmit}>

                                        <BankAccountFields
                                            values={values}
                                            handleChange={handleChange}
                                            touched={touched}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                        />


                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Button type="submit">Guardar Cuenta bancaria</Button>{' '}
                                                <Link to={'/catalogs/bankAccounts'} className="btn btn-info">Cancelar</Link>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>

                        </PanelBody>
                    </Panel>
                </div>

            </div>


        </div>

    );
}

export default NewBankAccount;